"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmaAuthzService = void 0;
var FirmaUtil_1 = require("./FirmaUtil");
var any_1 = require("./firmachain/google/protobuf/any");
var authz_1 = require("./firmachain/authz");
var AuthzTxTypes_1 = require("./firmachain/authz/AuthzTxTypes");
var timestamp_1 = require("./firmachain/google/protobuf/timestamp");
var FirmaAuthzService = /** @class */ (function () {
    function FirmaAuthzService(config) {
        this.config = config;
    }
    FirmaAuthzService.prototype.getSignedTxGrantSendAutorization = function (wallet, granteeAddress, maxTokens, expirationDate, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, authorization, timestamp, message, authzTxClient, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        authorization = any_1.Any.fromPartial({
                            typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
                            value: Uint8Array.from(AuthzTxTypes_1.SendAuthorization.encode(AuthzTxTypes_1.SendAuthorization.fromPartial({
                                spendLimit: [{ denom: this.config.denom, amount: maxTokens }],
                            })).finish()),
                        });
                        timestamp = timestamp_1.Timestamp.fromPartial({ seconds: expirationDate.getTime() / 1000 });
                        message = authz_1.AuthzTxClient.msgGrantAllowance({
                            granter: address,
                            grantee: granteeAddress,
                            grant: {
                                authorization: authorization,
                                expiration: timestamp
                            }
                        });
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getSignedTxGrantStakeAutorization = function (wallet, granteeAddress, validatorAddressList, type, maxTokens, expirationDate, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, authorization, timestamp, message, authzTxClient, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        authorization = any_1.Any.fromPartial({
                            typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
                            value: Uint8Array.from(AuthzTxTypes_1.StakeAuthorization.encode(AuthzTxTypes_1.StakeAuthorization.fromPartial({
                                allowList: { address: validatorAddressList },
                                maxTokens: (maxTokens === "0") ? undefined : { denom: this.config.denom, amount: maxTokens },
                                authorizationType: type
                            })).finish()),
                        });
                        timestamp = timestamp_1.Timestamp.fromPartial({ seconds: expirationDate.getTime() / 1000 });
                        message = authz_1.AuthzTxClient.msgGrantAllowance({
                            granter: address,
                            grantee: granteeAddress,
                            grant: {
                                authorization: authorization,
                                expiration: timestamp
                            }
                        });
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getSignedTxGrantGenericAuthorization = function (wallet, granteeAddress, msgType, expirationDate, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, authorization, timestamp, message, authzTxClient, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        authorization = any_1.Any.fromPartial({
                            typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
                            value: Uint8Array.from(AuthzTxTypes_1.GenericAuthorization.encode(AuthzTxTypes_1.GenericAuthorization.fromPartial({
                                msg: msgType
                            })).finish()),
                        });
                        timestamp = timestamp_1.Timestamp.fromPartial({ seconds: expirationDate.getTime() / 1000 });
                        message = authz_1.AuthzTxClient.msgGrantAllowance({
                            granter: address,
                            grantee: granteeAddress,
                            grant: {
                                authorization: authorization,
                                expiration: timestamp
                            }
                        });
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_3 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getSignedTxRevokeGenericAuthorization = function (wallet, granteeAddress, msgType, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, message, authzTxClient, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = authz_1.AuthzTxClient.msgRevokeAllowance({
                            granter: address,
                            grantee: granteeAddress,
                            msgTypeUrl: msgType
                        });
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_4 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // executeAllowance
    FirmaAuthzService.prototype.getSignedTxExecuteAllowance = function (wallet, msgs, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, message, authzTxClient, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = authz_1.AuthzTxClient.msgExecAllowance({
                            grantee: address,
                            msgs: msgs
                        });
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_5 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getGasEstimationGrantSendAuthorization = function (wallet, granteeAddress, expirationDate, maxTokens, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxGrantSendAutorization(wallet, granteeAddress, FirmaUtil_1.FirmaUtil.getUFCTStringFromFCT(maxTokens), expirationDate, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_6 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.grantSendAuthorization = function (wallet, granteeAddress, expirationDate, maxTokens, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, authzTxClient, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxGrantSendAutorization(wallet, granteeAddress, FirmaUtil_1.FirmaUtil.getUFCTStringFromFCT(maxTokens), expirationDate, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_7 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getGasEstimationGrantStakeAuthorization = function (wallet, granteeAddress, validatorAddressList, type, expirationDate, maxTokens, txMisc) {
        if (maxTokens === void 0) { maxTokens = 0; }
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxGrantStakeAutorization(wallet, granteeAddress, validatorAddressList, type, FirmaUtil_1.FirmaUtil.getUFCTStringFromFCT(maxTokens), expirationDate, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_8 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.grantStakeAuthorization = function (wallet, granteeAddress, validatorAddressList, type, expirationDate, maxTokens, txMisc) {
        if (maxTokens === void 0) { maxTokens = 0; }
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, authzTxClient, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxGrantStakeAutorization(wallet, granteeAddress, validatorAddressList, type, FirmaUtil_1.FirmaUtil.getUFCTStringFromFCT(maxTokens), expirationDate, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_9 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getGasEstimationGrantGenericAuthorization = function (wallet, granteeAddress, msg, expirationDate, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxGrantGenericAuthorization(wallet, granteeAddress, msg, expirationDate, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_10 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_10);
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.grantGenericAuthorization = function (wallet, granteeAddress, msg, expirationDate, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, authzTxClient, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxGrantGenericAuthorization(wallet, granteeAddress, msg, expirationDate, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_11 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_11);
                        throw error_11;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getGasEstimationRevokeGenericAuthorization = function (wallet, granteeAddress, msgType, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxRevokeGenericAuthorization(wallet, granteeAddress, msgType, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_12 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_12);
                        throw error_12;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.revokeGenericAuthorization = function (wallet, granteeAddress, msgType, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, authzTxClient, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxRevokeGenericAuthorization(wallet, granteeAddress, msgType, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_13 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_13);
                        throw error_13;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getGasEstimationRevokeSendAuthorization = function (wallet, granteeAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgType, txRaw, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        msgType = "/cosmos.bank.v1beta1.MsgSend";
                        return [4 /*yield*/, this.getSignedTxRevokeGenericAuthorization(wallet, granteeAddress, msgType, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_14 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_14);
                        throw error_14;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.revokeSendAuthorization = function (wallet, granteeAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgType, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        msgType = "/cosmos.bank.v1beta1.MsgSend";
                        return [4 /*yield*/, this.revokeGenericAuthorization(wallet, granteeAddress, msgType, txMisc)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_15 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_15);
                        throw error_15;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getGasEstimationRevokeStakeAuthorization = function (wallet, granteeAddress, type, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgType, txRaw, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        msgType = "";
                        switch (type) {
                            case AuthzTxTypes_1.AuthorizationType.AUTHORIZATION_TYPE_DELEGATE:
                                msgType = "/cosmos.staking.v1beta1.MsgDelegate";
                                break;
                            case AuthzTxTypes_1.AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE:
                                msgType = "/cosmos.staking.v1beta1.MsgUndelegate";
                                break;
                            case AuthzTxTypes_1.AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE:
                                msgType = "/cosmos.staking.v1beta1.MsgBeginRedelegate";
                                break;
                            default:
                                throw "AuthorizationType Error : " + type;
                        }
                        return [4 /*yield*/, this.getSignedTxRevokeGenericAuthorization(wallet, granteeAddress, msgType, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_16 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_16);
                        throw error_16;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.revokeStakeAuthorization = function (wallet, granteeAddress, type, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var msgType, txRaw, authzTxClient, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        msgType = "";
                        switch (type) {
                            case AuthzTxTypes_1.AuthorizationType.AUTHORIZATION_TYPE_DELEGATE:
                                msgType = "/cosmos.staking.v1beta1.MsgDelegate";
                                break;
                            case AuthzTxTypes_1.AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE:
                                msgType = "/cosmos.staking.v1beta1.MsgUndelegate";
                                break;
                            case AuthzTxTypes_1.AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE:
                                msgType = "/cosmos.staking.v1beta1.MsgBeginRedelegate";
                                break;
                            default:
                                throw "AuthorizationType Error : " + type;
                        }
                        return [4 /*yield*/, this.getSignedTxRevokeGenericAuthorization(wallet, granteeAddress, msgType, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_17 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_17);
                        throw error_17;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getGasEstimationExecuteAllowance = function (wallet, msgs, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxExecuteAllowance(wallet, msgs, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_18 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_18);
                        throw error_18;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.executeAllowance = function (wallet, msgs, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, authzTxClient, error_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxExecuteAllowance(wallet, msgs, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        authzTxClient = new authz_1.AuthzTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, authzTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_19 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_19);
                        throw error_19;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // query
    FirmaAuthzService.prototype.getSendGrantData = function (granterAddress, granteeAddress, paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new authz_1.AuthzQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getSendGrantData(granterAddress, granteeAddress, paginationKey)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_20 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_20);
                        throw error_20;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getGenericGrantData = function (granterAddress, granteeAddress, msgType, paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new authz_1.AuthzQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getGenericGrantData(granterAddress, granteeAddress, msgType, paginationKey)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_21 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_21);
                        throw error_21;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaAuthzService.prototype.getStakingGrantData = function (granterAddress, granteeAddress, msgType, paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new authz_1.AuthzQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.getStakingGrantData(granterAddress, granteeAddress, msgType, paginationKey)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_22 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_22);
                        throw error_22;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return FirmaAuthzService;
}());
exports.FirmaAuthzService = FirmaAuthzService;
